var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"banner-01"}},[_c('article',{staticClass:"banner"},[_c('div',{staticClass:"banner-logo-webstars"})])])
}]

export { render, staticRenderFns }